import { getEffectiveSubscriptionPlan } from './workspace-entitlements'

/**
 * The AI Video editor is paid-only.
 *
 * Free accounts were signing up in bulk and spending their welcome credits on
 * video generation, so the editor now needs any paid plan — `basic`,
 * `basicPlus` or `pro`. Team-workspace members come through
 * `getEffectiveSubscriptionPlan`, which already resolves a workspace
 * entitlement to `pro`, so a seat on a team workspace counts as paid without a
 * personal subscription.
 *
 * Same shape as `modules/Storyboard/sceneWorkflowAccess`, which gates that
 * surface on `pro` alone.
 */
export const canAccessVideoEditor = (options = {}) => {
  return getEffectiveSubscriptionPlan(options) !== 'free'
}

export default canAccessVideoEditor
